import { ReferencedEntry } from 'contentful';
import React from 'react';

import { IEntryWrapperProps } from './IEntryWrapperProps';

export function withEntryAttributes<
  TFields,
  TEntity extends ReferencedEntry<TFields> = ReferencedEntry<TFields>,
  TProps extends IEntryWrapperProps<TFields, TEntity> = IEntryWrapperProps<TFields, TEntity>,
  TReturn extends Partial<TProps> = Partial<TProps>
  >(mapProps: (props: TProps) => TReturn) {
  return function WithEntryAttributes<TDefaultProps>(Wrapped: React.ComponentType<TProps & Partial<TReturn>> & { defaultProps?: TDefaultProps}) {
    const WithEntryAttributesWrapper: React.FC<TProps & IEntryWrapperProps<TFields, TEntity> & TReturn & TDefaultProps> = props => (
      <Wrapped
        {...props}
        {...mapProps(props)}
      />
    );

    if (Wrapped.defaultProps) {
      WithEntryAttributesWrapper.defaultProps = Wrapped.defaultProps;
    }

    return WithEntryAttributesWrapper;
  };
}
